import { createSlice } from '@reduxjs/toolkit';
import errorWrapper from '~/redux/reducers/utils/errorWrapper';
import * as actions from './actions';
const metadataSlice = createSlice({
    name: 'organizationMetadata',
    initialState: {
        loadingMetadata: false,
        orgMetadata: null,
    },
    reducers: {},
    extraReducers: {
        [actions.getOrganizationMetadata.pending]: state => {
            state.loadingMetadata = true;
            state.orgMetadata = null;
        },
        [actions.getOrganizationMetadata.fulfilled]: (state, action) => {
            state.loadingMetadata = false;
            state.orgMetadata = action.payload;
        },
        [actions.getOrganizationMetadata.rejected]: (state, action) => {
            var _a;
            state.loadingMetadata = false;
            state.orgMetadata = null;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
    },
});
export * from './actions';
export default errorWrapper(metadataSlice.reducer);
